import classNames from 'classnames';
import React, {FC} from 'react';
import styles from './Image.module.scss';

export type ImageProps = {
    layout?: 'fill';
    className?: string;
};

export const Image: FC<ImageProps> = ({ layout, className, children }) => {
	return (
		<span
			className={classNames(styles.image, 'image', className, {
				[styles[`image--${layout}`]]: layout,
				['position-absolute w-100 h-100 top-0 start-0']: layout === 'fill',
			})}
		>
			<span className="position-relative d-block w-100 h-100">{children}</span>
		</span>
	);
};
